import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import classes from "../DashboardStyles/DashboardStyles.module.css";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect,useState } from "react";
import ProfileCard from "../../components/common/ProfileCard/ProfileCard";
import DashboardHeaderActions from "../../components/common/DashboardHeaderActions/DashboardHeaderActions";

const OrganisationDashboard = () => {
  const sideBarToggled = useSelector((data) => data?.sideBarToggle.value);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [roles, setRoles] = useState({
      SuperAdmin: false,
      Admin: false,
      Buyer: false,
      VendorAdmin: false,
      VendorContact: false,
      User: false,
    });


  const profilePath = roles.Buyer
      ? "/Buyer_dashboard/My_profile"
      : roles.VendorAdmin || roles.VendorContact
      ? "/Vendor_dashboard/My_profile"
      : "/Organization_dashboard/My_profile";

  return (
    <div
      className={classes.dashboard_wrapper}
      style={{
        marginLeft: isMobile ? "0" : sideBarToggled ? "80px" : "330px",
        transition: "margin-left 0.3s ease",
      }}
    >
      <div className={classes.HeaderBar}>
        {isMobile && <Sidebar />}
        {!isMobile && <Sidebar />}
        <DashboardHeaderActions
          profileNode={
            <ProfileCard
              hideMenu={false}
              profilePath={profilePath}
              vendorBtn={roles.VendorAdmin || roles.VendorContact}
              vendorBtnOutlined={roles.VendorAdmin || roles.VendorContact}
              buyerBtn={roles.Buyer || roles.User}
              buyerBtnOutline={roles.Buyer || roles.User}
            />
          }
        />
      </div>

      <div
        className={
          sideBarToggled ? classes.mainContentClose : classes.mainContent
        }
      >
        <Outlet />
      </div>
    </div>
  );
};

export default OrganisationDashboard;
